import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './Toaster.scss'

export const Toaster = () => {
  return <ToastContainer transition={Slide} position="top-center" />
}
